import { useEffect, useState } from "react";
import { fmtDate } from "@/components/DatePicker";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

export function LateReasonDialog({ item, onConfirm, onClose }) {
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  useEffect(() => { api.get("/tax-impound/late-reasons").then((r) => setReasons(r.data)).catch(() => {}); }, []);
  useEffect(() => { setReason(item?.late_reason || ""); setNote(item?.late_note || ""); }, [item]);
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="late-reason-dialog">
        <DialogHeader><DialogTitle className="font-display">Why was this deposit late?</DialogTitle><DialogDescription>{item?.tax_type} was due {fmtDate(item?.due_date)}. The reason is stored with the liability and rolled up into late-deposit trends on the Bureau Overview.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <Select value={reason} onValueChange={setReason}><SelectTrigger data-testid="late-reason-select" className="h-10"><SelectValue placeholder="Select a root cause" /></SelectTrigger><SelectContent>{reasons.map((r) => <SelectItem key={r.key} value={r.key} data-testid={`late-reason-opt-${r.key}`}>{r.label}</SelectItem>)}</SelectContent></Select>
          <Textarea data-testid="late-reason-note" placeholder="Optional detail (what happened, who was contacted, what changes to prevent it)" value={note} onChange={(e) => setNote(e.target.value)} rows={3} />
        </div>
        <DialogFooter>
          <Button variant="outline" data-testid="late-reason-cancel" onClick={onClose}>Cancel</Button>
          <Button data-testid="late-reason-confirm" disabled={!reason} onClick={() => onConfirm(reason, note)}>Save & mark paid</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
